import { Grid, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import KenDialog from '../../../global_components/KenDialogBox';
import KenSelectWrap from '../../../global_components/KenSelect';
import KenDateTimePicker from '../../../global_components/KenDateTimePicker';
import { makeStyles, withStyles } from '@material-ui/styles';
import {
  postAcademicCalendar,
} from '../../../Utils/apiServices';

// style
const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },

  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  actionBtn: {
    // margin: '0 10 px',
    float: 'right',
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
  },
  popOverTitle: {
    width: '216px',
    minWidth: '200px',
    height: '27px',
    color: '#ffffff',
    backgroundColor: '#092682',
    fontSize: '14px',
    fontWeight: '600',
    padding: '3px 15px',
  },
  holidayButton: {
    textTransform: 'none',
    fontWeight: 'bold',
    marginRight: '5px',
  },
  fitlerButton: {
    textTransform: 'none',
    fontWeight: 'bold',
  },
  sortingSection: {
    display: 'grid',
    gap: '10px',
    gridTemplateColumns: 'repeat(7, 1fr)',
  },
  popOverData: {
    width: '216px',
    minWidth: '200px',
    height: '27px',
    color: '#092682',
    fontSize: '12px',
    fontWeight: '600',
    padding: '3px 15px',
  },
  mainActions: {
    textAlign: 'right',
  },
  popOverHeading: {
    width: '100%',
    fontSize: '14px',
    fontWeight: '400',
    color: '#02195E',
  },
  tableBodyStyle: {
    fontSize: '12px',
    color: '#7A869A',
  },
  tableBodyStyleIgnoreHoliday: {
    fontSize: '12px',
    color: '#7A869A',
    padding: '0px',
  },
  textInputFieldDropDown: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  textInputField: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  kenDateTimePickerColor: {
    backgroundColor: '#fff',
  },
  noDataFound: {
    fontWeight: '600',
    fontSize: '14px',
  },
  filterButton: {
    marginRight: '10px',
  },
}));
// Add and Edit Reference Dialogue
const Reference = ({
  title,
  children,
  isOpen,
  handleClose,
  handleEvent,
  positiveBtn,
  negativeBtn,
  handleSelectSubjectChange,
  sessions,
  subjects,
  facultyOptions,
  selectSubjectValue,
  id,
  programName,
  year,
  intake,
  term,
}) => {
  const classes = useStyles();
  // all State
  const [sessionValue, setSessionValue] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [facultyName, setFacultyName] = useState('');
  const [facultyNameTwo, setFacultyNameTwo] = useState('');
  const [facultyNameThree, setFacultyNameThree] = useState('');
  // const [selectSubjectValue, setSelectSubjectValue] = React.useState('');
  console.log('id-------------', id);
  // all methods
  const handleSelectProgramChange = (e, value) => {
    setSessionValue(e.target.value);
  };

  const handleChangedStartDate = (e) => {
    setStartDate(e.target.value);
  };

  const handleChangedEndDate = (e) => {
    setEndDate(e.target.value);
  };
  const handleSelectFacultyChange = (e, value) => {
    setFacultyName(e.target.value);
  };

  const handleSelectFacultyTwoChange = (e, value) => {
    setFacultyNameTwo(e.target.value);
  };

  const handleSelectFacultyThreeChange = (e, value) => {
    setFacultyNameThree(e.target.value);
  };
  const handleUpdateEventRefernce = async () => {
    console.log('adddd- edit');
    const objRef = {
      weekNumber: '2',
      typeofActivity: sessionValue,
      termId: term,
      startDate: `${startDate}T00:00:00.000Z`,
      endDate: `${endDate}T00:00:00.000Z`,
      academicCalenderName: `${programName} ${year} ${intake} ${term}`,
    };
    await postAcademicCalendar([objRef]);
    // toast.success('Update successfully');
    // setConfirmDialogAddReference(false);
    // setConfirmDialogReferenceView(false);
  };
  const handleAddEventRefernce = async () => {
    console.log('adddd');
    const objRef = {
      weekNumber: '2',
      typeofActivity: sessionValue,
      termId: term,
      startDate: `${startDate}T00:00:00.000Z`,
      endDate: `${endDate}T00:00:00.000Z`,
      academicCalenderName: `${programName} ${year} ${intake} ${term}`,
    };

    const res = await postAcademicCalendar([objRef]);
    // toast.success('Update successfully');
    // setConfirmDialogAddReference(false);
    // setConfirmDialogReferenceView(false);
    handleClose();
  };
  return (
    <div>
      {' '}
      <KenDialog
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            {<b>{title}</b>}
          </Typography>
        }
        open={isOpen}
        // icon={<RiCheckFill />}
        handleClose={handleClose}
        negativeButtonClick={
          handleClose
          // (e) => setConfirmDialogAdd(false)
        }
        positiveButtonClick={
          id ? handleUpdateEventRefernce : handleAddEventRefernce
        }
        positiveButtonText={positiveBtn}
        negativeButtonText={negativeBtn}
        dividers
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <KenSelectWrap
              // disabled={readOnly}
              label="Type of Activity"
              options={sessions}
              value={sessionValue}
              dropdownColor="#FFFFFF"
              onChange={handleSelectProgramChange}
              // styles={CustomStyle}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <KenDateTimePicker
              name={'startDate'}
              label="Start Date"
              // disabled={readOnly}
              value={startDate}
              type="date"
              required={true}
              // defaultValue={startData}
              onChange={handleChangedStartDate}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <KenDateTimePicker
              name={'endDate'}
              label="End Date"
              // disabled={readOnly}
              value={endDate}
              type="date"
              required={true}
              // defaultValue={startData}
              onChange={handleChangedEndDate}
            />
          </Grid>
        </Grid>
      </KenDialog>
    </div>
  );
};

export default Reference;
